import text from 'I18n/utils/unescapedText';
import { useEffect } from 'react';
import TaskSettingsContainer from '../containers/TaskSettingsContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TasksRoute() {
  useEffect(() => {
    document.title = text('CrmSettingsTaskReminders.documentTitle');
  }, []);
  return /*#__PURE__*/_jsx(TaskSettingsContainer, {});
}